import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./ScoradDetails.css";

const getDifficultyLevel = (score) => {
  const s = parseFloat(score || 0);
  if (s < 25) return { text: "Mild", color: "#4cd964" };
  if (s < 50) return { text: "Moderate", color: "#ffcc00" };
  return { text: "Severe", color: "#ff3b30" };
};

const ScoradDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  const [scoreList, setScoreList] = useState([]);
  const [selectedScore, setSelectedScore] = useState(null);
  const [signSymptoms, setSignSymptoms] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const PAGE_SIZE = 7;

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchScoradScore()
      .then((res) => {
        const scores = res.data.data?.scoradScore || [];
        const latestByDate = scores.reduce((acc, cur) => {
          const d = cur.logDate;
          if (!acc[d] || new Date(cur.lastUpdatedTime) > new Date(acc[d].lastUpdatedTime)) acc[d] = cur;
          return acc;
        }, {});
        setScoreList(Object.values(latestByDate).sort((a, b) => new Date(b.logDate) - new Date(a.logDate)));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleViewDetail = async (scoreItem) => {
    setSelectedScore(scoreItem);
    try {
      const res = await lifestyleApi.fetchSignSymptomsScore({ scoreId: scoreItem.scoreId });
      setSignSymptoms(res.data.data || null);
    } catch (err) {
      // fetchSignSymptomsScore error
    }
    setShowDetail(true);
  };

  const handleTakeScorad = () => {
    const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;
    navigate(`/scorad-bsa?${qs}`);
  };

  const paged = scoreList.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  if (loading) return <div className="sd-loading">{t("common.loading")}</div>;

  return (
    <section className="sd-page">
      {showDetail && selectedScore && (
        <div className="sd-modal-overlay" onClick={() => setShowDetail(false)}>
          <div className="sd-modal" onClick={(e) => e.stopPropagation()}>
            <button className="sd-modal-close" onClick={() => setShowDetail(false)}>✕</button>
            <h2 className="sd-modal-title">SCORAD Detail</h2>
            <div className="sd-modal-row"><span>Date:</span><span>{selectedScore.logDate}</span></div>
            <div className="sd-modal-row"><span>BSA:</span><span>{selectedScore.bsaScore}</span></div>
            <div className="sd-modal-row"><span>IO Sign:</span><span>{signSymptoms?.ioSignScore ?? "--"}</span></div>
            <div className="sd-modal-row"><span>IO Symptom:</span><span>{signSymptoms?.ioSymptomScore ?? "--"}</span></div>
            <div className="sd-modal-row"><span>SCORAD:</span><span>{selectedScore.scoradScore}</span></div>
          </div>
        </div>
      )}

      <div className="sd-take-btn-row">
        <button className="sd-take-btn" onClick={handleTakeScorad}>{t("scoradDetails.takeBtn")}</button>
      </div>

      {scoreList.length === 0 ? (
        <p className="sd-empty">{t("scoradDetails.noData")}</p>
      ) : (
        <>
          <div className="sd-page-nav">
            <button className="sd-nav-btn" disabled={page === 0} onClick={() => setPage((p) => p - 1)}>&#8249;</button>
            <span className="sd-page-label">{t("scoradDetails.page")} {page + 1}</span>
            <button className="sd-nav-btn" disabled={(page + 1) * PAGE_SIZE >= scoreList.length} onClick={() => setPage((p) => p + 1)}>&#8250;</button>
          </div>
          {paged.map((item, i) => {
            const diff = getDifficultyLevel(item.scoradScore);
            return (
              <div key={i} className="sd-score-card" onClick={() => handleViewDetail(item)}>
                <div className="sd-score-info">
                  <span className="sd-score-date">{item.logDate}</span>
                  <span className="sd-score-diff" style={{ color: diff.color }}>{diff.text}</span>
                </div>
                <span className="sd-score-val">{item.scoradScore}</span>
              </div>
            );
          })}
        </>
      )}
    </section>
  );
};

export default ScoradDetails;
